import { BROWSER } from './constants';

/**
 * Determines the browser of the current environment.
 *
 * This is a lightweight userAgent based detection intended for display / conditional rendering.
 */
export function getBrowser(): string {
  if (typeof navigator === 'undefined') {
    return BROWSER.UNKNOWN;
  }

  const ua = (navigator.userAgent || '').toLowerCase();

  if (ua.includes('edg/')) return BROWSER.EDGE;
  if (ua.includes('firefox/') || ua.includes('fxios')) return BROWSER.FIREFOX;

  const isChrome = ua.includes('chrome/') || ua.includes('crios');
  const isSafari = ua.includes('safari/');

  if (isChrome && !ua.includes('opr/') && !ua.includes('opera/')) return BROWSER.CHROME;
  if (isSafari && !isChrome) return BROWSER.SAFARI;

  return BROWSER.UNKNOWN;
}
